// Friends, presence and invites (Oct 2026) — client helpers for /api/friends.
import axios from "axios";
import { getShownFaction } from "@/lib/shownFaction";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opts = { withCredentials: true };
// Same anonymous session token the game pages use for online seats.
export function getSessionToken() {
  let t = null;
  try { t = window.localStorage.getItem("chess_session_token"); } catch { /* ignore */ }
  if (!t) {
    t = (window.crypto?.randomUUID?.() || `tok-${Date.now()}-${Math.random()}`).toString();
    try { window.localStorage.setItem("chess_session_token", t); } catch { /* ignore */ }
  }
  return t;
}
export const friendsApi = {
  list: () => axios.get(`${API}/friends`, opts).then((r) => r.data),
  search: (q) => axios.get(`${API}/friends/search?q=${encodeURIComponent(q)}`, opts).then((r) => r.data.users),
  request: (userId) => axios.post(`${API}/friends/request`, { user_id: userId }, opts).then((r) => r.data),
  respond: (userId, accept) => axios.post(`${API}/friends/respond`, { user_id: userId, accept }, opts).then((r) => r.data),
  remove: (userId) => axios.post(`${API}/friends/remove`, { user_id: userId }, opts).then((r) => r.data),
  invites: () => axios.get(`${API}/friends/invites`, opts).then((r) => r.data.invites),
  answerInvite: (id, accept) => axios.post(`${API}/friends/invites/${id}/respond`, { accept }, opts).then((r) => r.data),
  heartbeat: (gameId) =>
    axios.post(`${API}/friends/heartbeat${gameId ? `?game_id=${encodeURIComponent(gameId)}` : ""}`, {}, opts).catch(() => null),
};
// Create a 2-seat online game as host, then invite the friend to it.
export async function challengeFriend(friendId, gameMode, nickname) {
  const created = await axios.post(`${API}/games`, {
    human_positions: ["south", "north"],
    difficulty: "medium",
    game_mode: gameMode,
    online: true,
    nickname: nickname || "Commander",
    session_token: getSessionToken(),
    faction: getShownFaction(),
  }, opts);
  const gameId = created.data.id;
  await axios.post(`${API}/friends/invite`, { user_id: friendId, game_id: gameId }, opts);
  return gameId;
}
// Accept an invite: take the first open seat, then mark the invite accepted.
export async function joinInvite(invite, nickname) {
  const g = await axios.get(`${API}/games/${invite.game_id}`).then((r) => r.data);
  const seat = (g.players || []).find((p) => p.slot_type === "open");
  if (!seat) throw new Error("That table is already full");
  await axios.post(`${API}/games/${invite.game_id}/join`, {
    position: seat.position,
    nickname: nickname || "Commander",
    session_token: getSessionToken(),
    faction: getShownFaction(),
  }, opts);
  await friendsApi.answerInvite(invite.id, true);
  return invite.game_id;
}
